// extracted by mini-css-extract-plugin
export default {"container":"painting_thumbnails_container__6XEAl","list":"painting_thumbnails_list__Kjr-c"};